module.exports = __webpack_public_path__ + "static/vasano_frame4.9d1119cb.gif";


//////////////////
// WEBPACK FOOTER
// ./assets/animation/vasano_frame4.gif
// module id = ./assets/animation/vasano_frame4.gif
// module chunks = 170844033123148